export function formatTime(seconds) {
  if (!Number.isFinite(seconds)) return "0:00"

  const total = Math.floor(seconds)
  const minutes = Math.floor(total / 60)
  const remainingSeconds = total % 60

  return `${minutes}:${String(remainingSeconds).padStart(2, "0")}`
}
